// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'user-solid';

export const Component = () => (
  <path d='M7.5 7.476c0-1.366.488-2.537 1.463-3.513C9.94 2.988 11.11 2.5 12.476 2.5c1.415 0 2.585.488 3.56 1.463.976.976 1.464 2.146 1.464 3.513 0 1.415-.488 2.585-1.463 3.56-.976.976-2.146 1.464-3.561 1.464-1.366 0-2.537-.488-3.513-1.463C7.988 10.06 7.5 8.89 7.5 7.476Zm5 6c2.195 0 4.097.78 5.658 2.341C19.72 17.38 20.5 19.28 20.5 21.476v.488c0 .341-.146.536-.488.536H5.036c-.341 0-.536-.195-.536-.536v-.488c0-2.196.78-4.049 2.342-5.61 1.61-1.61 3.463-2.39 5.658-2.39Z' />
);

export const viewBox = '0 0 25 25';
